export default {"src":"/_next/static/media/slr.dd177b9c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};